import { type ProgramType } from 'Program';

// We're implicitly relying on the order of these enum values to determine
// the display order of the category subsections in the selectProgram page
// (see selectProgramConfig.ts).
export enum ExecEdCertCategory {
    rise_to_c_suite = 'rise_to_c_suite',
    data_and_finance = 'data_and_finance',
    ai_and_future_of_business = 'ai_and_future_of_business',
}

export type EligibleProgram = {
    programType: ProgramType;
    scholarshipLevel: number;
};

export type ExecEdEligibilityBundle = {
    createdAt: string;
    updatedAt: string;
    userId: string;
    id: string;
    recommendedProgramType: ProgramType;
    eligiblePrograms: EligibleProgram[];
    activatedAt: number | null;
};

export type ExecEdCertCategoryConfig = {
    programTypes: ProgramType[];
    modalHeadingLocale: { key: string; values?: Record<string, string | number> };
    displaySortOrder: number;
};
